import { useState, useEffect } from 'react';

export default function HomePage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const heroSlides = [
    {
      image:
        "https://static.readdy.ai/image/f3447221557994dbfc306bed6cad7d66/a95969e9f11fa841ac120c9aacb3b7a4.jpeg",
      title: "R Sign Services",
      subtitle: "Premier Signage Fabrication & Installation in Los Angeles",
    },
    {
      image:
        "https://public.readdy.ai/ai/img_res/b31496b96a227cf7cfe43433eedf1c6f.jpg",
      title: "Expert Installation Services",
      subtitle: "Local & Statewide Coverage",
    },
    {
      image:
        "https://readdy.ai/api/search-image?query=Impressive%20collection%20of%20completed%20custom%20signs%20including%20monument%20signs%2C%20pylon%20signs%2C%20and%20architectural%20signage%20for%20major%20brands%20displayed%20in%20professional%20portfolio%20style&width=1920&height=800&seq=hero3&orientation=landscape",
      title: "Trusted by Major Brands",
      subtitle: "Carter's • Skechers • UCLA Health • Equity Union",
    },
    {
      image:
        "https://static.readdy.ai/image/f3447221557994dbfc306bed6cad7d66/ce97a7da1381a4d77f7d220397c8bec3.jpeg",
      title: "State-of-the-Art Fabrication",
      subtitle: "7,200 Sq Ft Facility with Advanced Technology",
    },
    {
      image:
        "https://static.readdy.ai/image/f3447221557994dbfc306bed6cad7d66/b12eae6a630b15edc69e2524bcf1097b.png",
      title: "Illuminating Los Angeles",
      subtitle: "Premium LED Signage Solutions",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroSlides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage("");

    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      data.append(key, value.toString());
    }

    try {
      const response = await fetch(
        "https://readdy.ai/api/form/d417t8a2kqgi5a0pu9sg",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: data,
        }
      );

      if (response.ok) {
        setSubmitMessage(
          "Thank you! Your message has been sent successfully. We will contact you soon."
        );
        (e.target as HTMLFormElement).reset();
      } else {
        setSubmitMessage(
          "Sorry, there was an error sending your message. Please try again."
        );
      }
    } catch (error) {
      setSubmitMessage(
        "Sorry, there was an error sending your message. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <div className="flex items-center">
                <img
                  src="https://static.readdy.ai/image/f3447221557994dbfc306bed6cad7d66/b12eae6a630b15edc69e2524bcf1097b.png"
                  alt="R Sign Services Logo"
                  className="h-10 w-auto"
                />
              </div>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a
                  href="#"
                  className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer"
                >
                  Home
                </a>
                <a
                  href="#"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer"
                >
                  Services
                </a>
                <a
                  href="#"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer"
                >
                  Portfolio
                </a>
                <a
                  href="#"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer"
                >
                  About
                </a>
                <a
                  href="#"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer"
                >
                  Contact
                </a>
              </div>
            </div>
            <div className="hidden md:block">
              <button className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                Get Quote
              </button>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-red-600 cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Carousel */}
      <section className="relative h-screen overflow-hidden">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? "opacity-100" : "opacity-0"
            }`}
          >
            <div
              className="w-full h-full bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="relative z-10 h-full flex items-center">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                  <div className="max-w-3xl">
                    <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
                      {slide.title}
                    </h1>
                    <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
                      {slide.subtitle}
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4">
                      <button 
                        onClick={() => setIsContactModalOpen(true)}
                        className="bg-red-600 text-white px-8 py-4 rounded-lg hover:bg-red-700 transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer">
                        Get Free Quote
                      </button>
                      <button className="border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white hover:text-gray-900 transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer">
                        View Portfolio
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-colors z-20 cursor-pointer"
        >
          <i className="ri-arrow-left-line text-2xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-colors z-20 cursor-pointer"
        >
          <i className="ri-arrow-right-line text-2xl"></i>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                index === currentSlide ? "bg-white" : "bg-white/50"
              }`}
            />
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From design to installation, we provide comprehensive signage
              solutions for businesses across Los Angeles
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-building-line",
                title: "Channel Letters",
                description:
                  "Custom illuminated channel letters for maximum visibility and brand impact",
              },
              {
                icon: "ri-road-map-line",
                title: "Monument Signs",
                description:
                  "Impressive ground-mounted signs that make a lasting first impression",
              },
              {
                icon: "ri-lightbulb-line",
                title: "LED Displays",
                description:
                  "Dynamic digital signage solutions for modern businesses",
              },
              {
                icon: "ri-store-line",
                title: "Storefront Signs",
                description:
                  "Eye-catching retail signage to attract customers and drive sales",
              },
              {
                icon: "ri-tools-line",
                title: "Installation & Maintenance",
                description:
                  "Professional installation and ongoing maintenance services",
              },
              {
                icon: "ri-palette-line",
                title: "Custom Design",
                description:
                  "Unique signage designs tailored to your brand and vision",
              },
            ].map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                  <i
                    className={`${service.icon} text-2xl text-red-600`}
                  ></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Featured Projects
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explore our portfolio of successful signage projects for leading
              brands and businesses
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                image:
                  "https://readdy.ai/api/search-image?query=Professional%20illuminated%20channel%20letters%20installation%20for%20Carters%20retail%20store%20showing%20modern%20storefront%20signage%20with%20clean%20white%20background%20and%20professional%20lighting&width=600&height=400&seq=portfolio1&orientation=landscape",
                title: "Carter's Retail Signage",
                category: "Channel Letters",
              },
              {
                image:
                  "https://readdy.ai/api/search-image?query=Impressive%20monument%20sign%20for%20Skechers%20corporate%20headquarters%20featuring%20modern%20design%20with%20LED%20lighting%20and%20landscaping%20on%20clean%20background&width=600&height=400&seq=portfolio2&orientation=landscape",
                title: "Skechers Monument Sign",
                category: "Monument Signs",
              },
              {
                image:
                  "https://readdy.ai/api/search-image?query=UCLA%20Health%20medical%20facility%20wayfinding%20signage%20system%20with%20modern%20directional%20signs%20and%20professional%20healthcare%20branding%20on%20clean%20background&width=600&height=400&seq=portfolio3&orientation=landscape",
                title: "UCLA Health Wayfinding",
                category: "Healthcare Signage",
              },
              {
                image:
                  "https://readdy.ai/api/search-image?query=Equity%20Union%20financial%20institution%20exterior%20signage%20with%20professional%20channel%20letters%20and%20modern%20architectural%20integration%20on%20clean%20background&width=600&height=400&seq=portfolio4&orientation=landscape",
                title: "Equity Union Signage",
                category: "Financial Services",
              },
              {
                image:
                  "https://readdy.ai/api/search-image?query=Modern%20LED%20digital%20display%20sign%20for%20commercial%20building%20showing%20dynamic%20content%20capabilities%20with%20professional%20installation%20on%20clean%20background&width=600&height=400&seq=portfolio5&orientation=landscape",
                title: "Digital LED Display",
                category: "LED Displays",
              },
              {
                image:
                  "https://readdy.ai/api/search-image?query=Custom%20architectural%20signage%20for%20luxury%20commercial%20building%20featuring%20elegant%20design%20and%20premium%20materials%20with%20professional%20lighting%20on%20clean%20background&width=600&height=400&seq=portfolio6&orientation=landscape",
                title: "Luxury Commercial Complex",
                category: "Architectural Signage",
              },
            ].map((project, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-xl mb-4">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors"></div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {project.title}
                </h3>
                <p className="text-red-600 font-medium">{project.category}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Our Facility
7,200 sq ft of cutting-edge equipment and skilled craftsmanship
              </h2>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                With over 15 years of experience in the signage industry,
                we've built our reputation on quality craftsmanship,
                innovative design, and exceptional customer service.
              </p>

              <div className="space-y-6">
                {[
                  {
                    icon: "ri-settings-3-line",
                    title: "CNC Router for precision cutting",
                    description:
                      "Advanced computer-controlled cutting for exact specifications",
                  },
                  {
                    icon: "ri-flashlight-line",
                    title: "Laser cutting technology",
                    description:
                      "High-precision laser systems for intricate designs and clean edges",
                  },
                  {
                    icon: "ri-brush-line",
                    title: "Professional paint booth",
                    description:
                      "Climate-controlled environment for flawless finishes",
                  },
                  {
                    icon: "ri-lightbulb-flash-line",
                    title: "LED assembly stations",
                    description:
                      "Specialized workstations for professional LED integration",
                  },
                  {
                    icon: "ri-shield-check-line",
                    title: "Quality control testing area",
                    description:
                      "Comprehensive testing facilities to ensure perfect performance",
                  },
                ].map((feature, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${feature.icon} text-xl text-red-600`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src="https://static.readdy.ai/image/f3447221557994dbfc306bed6cad7d66/e67a15aa86c45f6a3f298ffc9fc27fdf.png"
                alt="R Sign Services Facility"
                className="w-full h-auto rounded-xl shadow-lg object-cover object-top"
              />
              <div className="absolute -bottom-6 -left-6 bg-red-600 text-white p-6 rounded-xl">
                <div className="text-3xl font-bold">15+</div>
                <div className="text-sm">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-red-600 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to Transform Your Business with Professional Signage?
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Get a free consultation and quote for your custom sign project today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => setIsContactModalOpen(true)}
              className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
            </button>
            <button
              onClick={() => setIsContactModalOpen(true)}
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition duration-300 whitespace-nowrap cursor-pointer"
            >
              Call 310.878.2009
            </button>
          </div>
        </div>
      </section>

      {/* Contact Modal */}
      {isContactModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-gray-900">
                  Contact R Sign Services
                </h3>
                <button
                  onClick={() => setIsContactModalOpen(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <form
                id="contact_inquiry"
                data-readdy-form
                onSubmit={handleContactSubmit}
                className="space-y-4"
              >
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="Your full name"
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="your@email.com"
                  />
                </div>

                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="(310) 123-4567"
                  />
                </div>

                <div>
                  <label
                    htmlFor="service_type"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Service Type
                  </label>
                  <select
                    id="service_type"
                    name="service_type"
                    className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                  >
                    <option value="">Select a service</option>
                    <option value="Custom Business Signs">
                      Custom Business Signs
                    </option>
                    <option value="Vehicle Wraps">Vehicle Wraps</option>
                    <option value="Banners & Displays">
                      Banners & Displays
                    </option>
                    <option value="LED Signs">LED Signs</option>
                    <option value="Window Graphics">Window Graphics</option>
                    <option value="Trade Show Displays">
                      Trade Show Displays
                    </option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="project_details"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Project Details
                  </label>
                  <textarea
                    id="project_details"
                    name="project_details"
                    rows={4}
                    maxLength={500}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm resize-none"
                    placeholder="Tell us about your sign project, dimensions, timeline, and any specific requirements..."
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1">
                    Maximum 500 characters
                  </div>
                </div>

                {/* Project Files Input */}
                <div>
                  <label
                    htmlFor="project_files"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Project Files
                  </label>
                  <div className="relative">
                    <input
                      type="file"
                      id="project_files"
                      name="project_files"
                      multiple
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif"
                      className="hidden"
                    />
                    <label
                      htmlFor="project_files"
                      className="w-full px-3 py-2 border-2 border-dashed border-gray-300 rounded-md hover:border-red-500 transition-colors cursor-pointer flex items-center justify-center text-sm text-gray-600 hover:text-red-600"
                    >
                      <i className="ri-upload-cloud-line text-lg mr-2"></i>
                      Drop files here or click to browse
                    </label>
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    Accepted formats: PDF, DOC, DOCX, JPG, PNG, GIF (Max 10MB each)
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="budget_range"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Budget Range
                  </label>
                  <select
                    id="budget_range"
                    name="budget_range"
                    className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                  >
                    <option value="">Select budget range</option>
                    <option value="Under $500">Under $500</option>
                    <option value="$500 - $1,000">$500 - $1,000</option>
                    <option value="$1,000 - $2,500">$1,000 - $2,500</option>
                    <option value="$2,500 - $5,000">$2,500 - $5,000</option>
                    <option value="$5,000 - $10,000">$5,000 - $10,000</option>
                    <option value="Over $10,000">Over $10,000</option>
                  </select>
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="newsletter"
                    name="newsletter"
                    value="yes"
                    className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                  />
                  <label
                    htmlFor="newsletter"
                    className="ml-2 block text-sm text-gray-700"
                  >
                    Subscribe to our newsletter for sign design tips and special
                    offers
                  </label>
                </div>

                {submitMessage && (
                  <div
                    className={`p-3 rounded-md text-sm ${
                      submitMessage.includes("successfully")
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {submitMessage}
                  </div>
                )}

                <div className="flex gap-3 pt-4">
                  <button
                    type="button"
                    onClick={() => setIsContactModalOpen(false)}
                    className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition duration-300 whitespace-nowrap cursor-pointer"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex-1 bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 disabled:opacity-50 transition duration-300 whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <img
                src="https://static.readdy.ai/image/f3447221557994dbfc306bed6cad7d66/b12eae6a630b15edc69e2524bcf1097b.png"
                alt="R Sign Services Logo"
                className="h-10 w-auto mb-4"
              />
              <p className="text-gray-400 mb-6">
                Premier signage fabrication and installation services in Los
                Angeles and throughout California.
              </p>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="text-gray-400 hover:text-white cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    Channel Letters
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    Monument Signs
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    LED Displays
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    Installation
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    Portfolio
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    Careers
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white cursor-pointer"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <i className="ri-phone-line text-red-400"></i>
                  <span className="text-gray-400">310.878.2009</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-mail-line text-red-400"></i>
                  <span className="text-gray-400">info@rsignservices.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-map-pin-line text-red-400"></i>
                  <span className="text-gray-400">Los Angeles, CA</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 R Sign Services. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              className="text-gray-400 hover:text-white text-sm cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
